// extracted by mini-css-extract-plugin
export var aircallIframe = "_hp-3";
export var fabContainer = "_hp-5";
export var fabRinging = "_hp-6";
export var loadingOverlay = "_hp-4";
export var pulse = "_hp-7";
export var widgetContent = "_hp-2";
export var widgetPanel = "_hp-0";
export var widgetPanelExpanded = "_hp-1";